import random from 'lodash/random';

class Liner {
  static PI2 = Math.PI / 180;

  constructor(ctx, rad, opt) {
    this.ctx = ctx;
    this.opt = opt;
    this.rad = rad;
    this.deg = random(360, 0);
    if (Array.isArray(opt.lineColors)) {
      this.colors = opt.lineColors;
    } else {
      this.color = opt.lineColor;
    }
  }

  getPosX = (d, r, cx) => (Math.cos(Liner.PI2 * d) * r) + cx;

  getPosY = (d, r, cy) => (Math.sin(Liner.PI2 * d) * r) + cy;

  setPos = () => {
    this.moveDeg = this.deg + (random(this.opt.lineWidth, 1) / 10);
    this.endRadius = random(this.opt.circleRadiusMax, this.opt.circleRadiusMin);

    this.startPos = {
      x: this.getPosX(this.deg, this.rad, this.opt.centralX),
      y: this.getPosY(this.deg, this.rad, this.opt.centralY),
    };

    this.movePos = {
      x: this.getPosX(this.moveDeg, this.rad, this.opt.centralX),
      y: this.getPosY(this.moveDeg, this.rad, this.opt.centralY),
    };

    this.endPos = {
      x: this.getPosX(this.moveDeg, this.endRadius, this.opt.centralX),
      y: this.getPosY(this.moveDeg, this.endRadius, this.opt.centralY),
    };
  };

  update = () => {
    this.setPos();
  };

  draw = () => {
    this.ctx.beginPath();
    this.ctx.lineWidth = 1;
    this.ctx.fillStyle = this.color ? this.color : this.colors[random(0, this.colors.length - 1)];
    this.ctx.moveTo(this.startPos.x, this.startPos.y);
    this.ctx.lineTo(this.movePos.x, this.movePos.y);
    this.ctx.lineTo(this.endPos.x, this.endPos.y);
    this.ctx.fill();
    this.ctx.closePath();
  };

  render = () => {
    this.update();
    this.draw();
  }
}

export default (canvas, opt) => {
  const option = Object.assign({}, {
    lineColor: 'white',
    lineWidth: 30,
    lineNum: 200,
    circleRadiusMax: 200,
    circleRadiusMin: 150,
    interval: 100,
  }, opt);

  const ctx = canvas.getContext('2d');
  const centralX = canvas.width / 2;
  const centralY = canvas.height / 2;
  const rad = Math.sqrt((centralX ** 2) + (centralY ** 2)) | 0; // eslint-disable-line no-bitwise
  const lines = [];

  const render = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < lines.length; i++) {
      lines[i].render();
    }
  };

  for (let i = 0; i < option.lineNum; i++) {
    lines[lines.length] = new Liner(ctx, rad, Object.assign({}, option, { centralX, centralY }));
  }
  render();
  return setInterval(render, option.interval);
};



// WEBPACK FOOTER //
// ./src/app/utils/FocusLine/FocusLine.js